import styled from 'styled-components';
import BaseTable from 'react-base-table';

export const Wrapper = styled.div`
  height: 650px;
  width: 100%;
`;

export const StyledBaseTable = styled(BaseTable)`
  font-size: 11px;
  border: none;
  box-shadow: none;

  .BaseTable__table-main {
    outline: none;
  }

  .BaseTable__row {
    padding: 15px;
  }

  .BaseTable__header-row {
    border-bottom: none;
    outline: none;
    padding: 0 15px;
  }

  .BaseTable__header-cell {
    font-weight: bold;
    font-size: 11px;
  }
`;
